// src/components/modals/ViewerCommentCodeModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from "reactstrap";

interface ViewerCommentCodeModalProps {
  isOpen: boolean;
  toggle: () => void;
  email: string;
  setEmail: (text: string) => void;
  onGenerate: () => void;
}

const ViewerCommentCodeModal: React.FC<ViewerCommentCodeModalProps> = ({
  isOpen, toggle, email, setEmail, onGenerate
}) => (
  <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`} id="modal-code-new">
    <ModalHeader 
      toggle={toggle}
      className="modal-header-style"
    >Receber código de comentário</ModalHeader>
    <ModalBody className="modal-body-style">
      <Label>Você vai receber um código no email informado abaixo</Label>
      <Input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Digite seu email"
      />
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button color="primary" onClick={onGenerate} id="btn-code-new">Gerar código</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default ViewerCommentCodeModal;
